import { Button, Col, InputNumber, Modal, Row, Form, Tooltip, message, Input } from 'antd';
import React, { Dispatch, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../../store';
import { addItemRequest } from '../../../../../store/ducks/estoqueCart/actions';
import { IEstoqueCart } from '../../../../../store/ducks/estoqueCart/types';

import { ModalEstoqueProps } from './types';

import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { ColorBlue, Container, TitleLabel, TooltipIcon } from './styles';
import { maskUnd, maskUndInt } from '../../../../../utils/mask';
import { useForm } from 'antd/lib/form/Form';
import moment from 'moment';

const ModalSolicitarRetorno: React.FC<ModalEstoqueProps> = ({
  record,
  detalhesEstoque,
  lote,
  numeroNota,
}) => {
  const [form] = useForm();
  const dispatch = useDispatch<Dispatch<Action>>();

  const estoque = useSelector((state: ApplicationState) => state.EstoqueCart.cart);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [qtdProduto, setQtdProduto] = useState<number | any>();
  const [controller, setController] = useState(false);
  const [reservado, setReservado] = useState<number | any>([]);

  const qtdReservado = reservado === undefined ? 0 : reservado?.reservado;
  const detalhesTemporario = detalhesEstoque === undefined ? 1 : detalhesEstoque;

  const isQuantity = record.disponivel === 0;
  const isValidity = record?.dtValidade && moment(record?.dtValidade).format() < moment().format();
  const isCheckNF = record.nuNota ? false : true;

  const showModal = () => {
    setIsModalVisible(true);
    form.setFieldsValue({
      qtdProd: '',
      qtdProdutoFracionado: '',
    });
    setQtdProduto('');
    setReservado(
      estoque.find(
        ({ controle, reservado, numNota, dtValidade }) =>
          controle === lote &&
          numNota === record.numNota &&
          dtValidade === record.dtValidade &&
          reservado
      )
    );
  };

  const handleOk = (values: any) => {
    setIsModalVisible(false);
    if (controller === true) {
      setController(false);
    }

    const drawerEstoque: IEstoqueCart = {
      numNota: record.numNota,
      nuNota: numeroNota || record.nuNota,
      nuCobertura: record?.nuCobertura,
      reservado: qtdProduto,
      quantidade: qtdProduto,
      qtdPadraoFracionado: detalhesEstoque === undefined ? 1 : detalhesEstoque,
      controle: record.controle,
      descricaoProduto: record.produto,
      codProduto: record.codProduto,
      codPagador: record.codPagador,
      nomePagador: record.pagador,
      siglaUnidade: record.siglaUnidade,
      parceiros: record.parceiro,
      codParceiro: record.codParceiro,
      cnpjCpf: record.cnpjCpfParceiro,
      inscricaoEstadual: record.inscricaoEstadualParceiro,
      nomeParceiro: record.parceiro,
      clienteRetira: false,
      cnpjCpfPagador: record.cnpjCpfPagador,
      inscricaoPagador: record.inscricaoEstadualPagador,
      numcontrato: record.numcontrato,
      dtValidade: record.dtValidade,
    };

    const index = estoque?.findIndex(
      ({ codProduto, controle, codPagador, codParceiro, inscricaoEstadual, numNota, dtValidade }) =>
        codProduto === drawerEstoque.codProduto &&
        controle === drawerEstoque.controle &&
        codPagador === drawerEstoque.codPagador &&
        codParceiro === drawerEstoque.codParceiro &&
        inscricaoEstadual === drawerEstoque.inscricaoEstadual &&
        numNota === drawerEstoque.numNota &&
        dtValidade === drawerEstoque.dtValidade
    );

    if (index !== -1 && index !== undefined) {
      const newEstoque = estoque;
      newEstoque[index] = {
        ...newEstoque[index],
        quantidade: (newEstoque[index].quantidade || 0) + qtdProduto,
        reservado: (newEstoque[index].reservado || 0) + qtdProduto,
      };

      dispatch(addItemRequest(newEstoque));
    } else {
      dispatch(addItemRequest([...estoque, drawerEstoque]));
    }

    message.success('Produto adicionado ao carrinho com sucesso!');
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onChange = (values: any) => {
    form.setFieldsValue({
      qtdProd: values,
      qtdProdutoFracionado: detalhesTemporario,
    });
    setQtdProduto(values);
  };

  const controlePrefix = qtdProduto;

  const modalSolicitarRetorno = (
    <Form form={form} initialValues={{ qtdProd: 0 }} id="key" name="basic">
      <Row gutter={24}>
        <Col md={7} sm={24} xs={24}>
          <TitleLabel>Pagador</TitleLabel>
          <Form.Item name="pagador">
            <strong id="pagador">{record.pagador}</strong>
            <p>
              Contrato: <strong>{record.numcontrato}</strong>
            </p>
          </Form.Item>
        </Col>

        <Col md={5} sm={24} xs={24}>
          <TitleLabel>Lote</TitleLabel>
          <Form.Item name="lote">
            <strong id="lote">{record.controle}</strong>
          </Form.Item>
        </Col>

        <Col md={5} sm={24} xs={24}>
          <TitleLabel>Quantidade</TitleLabel>
          <Form.Item name="qtdProd">
            <InputNumber
              style={{ width: '100%' }}
              placeholder="Qtd EX: 200"
              autoFocus={true}
              disabled={record.disponivel / detalhesTemporario - qtdReservado === 0}
              type="number"
              size="middle"
              max={record.disponivel / detalhesTemporario - qtdReservado}
              min={0.1}
              onChange={onChange}
              onFocus={(e) => onChange(e.target.value)}
            />

            <ColorBlue>{`DISPONÍVEL: ${maskUndInt(
              qtdProduto === undefined && detalhesEstoque === undefined
                ? record.disponivel
                : qtdProduto !== undefined && detalhesEstoque === undefined
                  ? record.disponivel - qtdReservado
                  : qtdProduto === undefined && detalhesEstoque !== undefined
                    ? record.disponivel / detalhesTemporario
                    : record.disponivel / detalhesTemporario - qtdReservado
            )} UN`}</ColorBlue>
          </Form.Item>
        </Col>

        <Col md={7} sm={24} xs={24}>
          <Form.Item name="qtdProdutoFracionado">
            <TitleLabel>
              Total
              <TooltipIcon
                placement="topRight"
                title={
                  record.disponivel / detalhesTemporario - qtdReservado === 0
                    ? '*Este produto não tem quantidade disponível para solicitar.'
                    : `Este produto só pode ser solicitado em frações de ${detalhesTemporario} ${record.siglaUnidade}.`
                }
              >
                <QuestionCircleOutlined />
              </TooltipIcon>
            </TitleLabel>
            <Input
              style={{ width: '85%' }}
              autoFocus={true}
              id="qtdProdutoFracionado"
              type="number"
              size="middle"
              min={1}
              max={record.disponivel - qtdReservado}
              suffix={
                controlePrefix?.detail === 0
                  ? ''
                  : 'x ' +
                  detalhesTemporario +
                  ' ' +
                  record.siglaUnidade +
                  ' = ' +
                  maskUnd(qtdProduto * detalhesTemporario) +
                  ' ' +
                  record.siglaUnidade
              }
              disabled={true}
              value={qtdProduto}
            />
            <ColorBlue>{`TOTAL DISPONÍVEL: ${maskUndInt(
              qtdProduto === undefined && detalhesEstoque === undefined
                ? record.disponivel
                : qtdProduto !== undefined && detalhesEstoque === undefined
                  ? record.disponivel - qtdReservado
                  : qtdProduto === undefined && detalhesEstoque !== undefined
                    ? record.disponivel - qtdReservado || record.disponivel
                    : record.disponivel - qtdReservado * detalhesTemporario
            )} ${record.siglaUnidade}`}</ColorBlue>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );

  return (
    <>
      <Tooltip
        title={
          isQuantity
            ? 'Este produto não tem quantidade disponível para solicitar.'
            : isValidity
              ? 'Produto fora do prazo de validade'
              : isCheckNF
                ? "Não foi localizado a NF deste produto."
                : ""
        }
      >
        <Button
          data-cy="btnSolicitarRetorno"
          type="primary"
          disabled={isQuantity === true || isValidity === true || isCheckNF}
          onClick={showModal}
        >
          Solicitar retorno
        </Button>
      </Tooltip>
      <Container>
        <Modal
          centered
          title="Solicitar retorno"
          visible={isModalVisible}
          okText="Adicionar"
          className="modalRetorno"
          onOk={handleOk}
          cancelText="Cancelar"
          onCancel={handleCancel}
          maskClosable={false}
          closable={true}
          destroyOnClose={true}
          closeIcon={<CloseOutlined />}
          keyboard={true}
          width={detalhesEstoque === undefined ? 1000 : 900}
          footer={[
            <Button key="back" type="ghost" size="middle" onClick={handleCancel}>
              Cancelar
            </Button>,
            record.disponivel / detalhesTemporario - qtdReservado === 0 ? (
              <Tooltip title="*Este produto não tem quantidade disponível para solicitar.">
                <Button
                  disabled={record.disponivel / detalhesTemporario - qtdReservado === 0}
                  form="key"
                  htmlType="submit"
                  type="primary"
                  onClick={() => {
                    form.validateFields().then((values) => {
                      handleOk(values);
                    });
                  }}
                >
                  Adicionar
                </Button>
              </Tooltip>
            ) : (
              <Button
                disabled={qtdProduto === ''}
                form="key"
                htmlType="submit"
                type="primary"
                onClick={() => {
                  form.validateFields().then((values) => {
                    handleOk(values);
                  });
                }}
              >
                Adicionar
              </Button>
            ),
          ]}
        >
          {modalSolicitarRetorno}
        </Modal>
      </Container>
    </>
  );
};

export default ModalSolicitarRetorno;
